rdefine('app/products/collections/Variants',['backbone','app/products/models/Variant'],function(Backbone,Variant){
    return Backbone.Ribs.Collection.extend({
        model:Variant,
        setActive:function(variant) {
            _.each(this.models, function (item) {
                if (item === variant) {
                    item.set("active", true);
                } else {
                    item.set("active", false);
                }
            }.bind(this));
            this.trigger("choice-variant", variant);
        },
        setActiveLast:function() {
            this.setActive(this.models.slice(this.models.length-1,this.models.length)[0]);
        },
        checkActive:function() {
            if(!this.where({active:true}).length) {
                this.models[0].set("active",true);
            }
        }
    })
});